import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ContactSection from '../../components/ContactSection';
import Image from '../../components/AppImage';
import { Phone } from 'lucide-react';

const VehicleDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const vehicle = location?.state?.vehicle;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const vehicleSpecs = {
    'Innova Crysta 7+1': {
      seatingCapacity: '7+1',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'No',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Kia Carens': {
      seatingCapacity: '6',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Urbania': {
      seatingCapacity: '12',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'Yes',
      captainSeats: 'Yes',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Brezza': {
      seatingCapacity: '4',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'No',
      fuelType: 'Petrol',
      luggageCarrier: 'No',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'No',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Tempo Traveller': {
      seatingCapacity: '17',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Force Urbania': {
      seatingCapacity: '16',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'Yes',
      captainSeats: 'Yes',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Innova Hycross': {
      seatingCapacity: '6',
      transmission: 'Automatic',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Hybrid',
      luggageCarrier: 'Yes',
      sunroof: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'No',
      captainSeats: 'Yes',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Fortuner': {
      seatingCapacity: '6',
      transmission: 'Automatic',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'Yes',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'Yes',
      middleBenchSeat: 'No',
      captainSeats: 'Yes',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Maruti Ertiga': {
      seatingCapacity: '6',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Petrol',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'No',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Innova Crysta': {
      seatingCapacity: '6',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'Yes',
      fuelType: 'Diesel',
      luggageCarrier: 'Yes',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'No',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    },
    'Maruti Dzire': {
      seatingCapacity: '4',
      transmission: 'Manual',
      ac: 'Yes',
      rearAcVents: 'No',
      fuelType: 'Petrol',
      luggageCarrier: 'No',
      sunroof: 'No',
      phoneCharger: 'Yes',
      musicSystem: 'Yes (Bluetooth & Aux)',
      smokingAllowed: 'No',
      petAllowed: 'Yes (INR-500 Extra)',
      recliningSeats: 'No',
      middleBenchSeat: 'Yes',
      captainSeats: 'No',
      airportParking: 'Airport parking fees are not included in the base fare.'
    }
  };

  const routes = [
  { from: 'Chandigarh', to: 'Noida', price: 3800 },
  { from: 'Delhi', to: 'Chandigarh', price: 3200 },
  { from: 'Chandigarh', to: 'Delhi', price: 3200 },
  { from: 'Delhi', to: 'Ludhiana', price: 4500 },
  { from: 'Delhi', to: 'Kharar', price: 3100 },
  { from: 'Chandigarh', to: 'Haridwar', price: 3300 },
  { from: 'Chandigarh', to: 'Jammu', price: 4200 },
  { from: 'Chandigarh', to: 'Manali', price: 4500 },
  { from: 'Chandigarh', to: 'Shimla', price: 2500 },
  { from: 'Chandigarh', to: 'Amritsar', price: 3000 },
  { from: 'Chandigarh', to: 'Delhi Airport', price: 3200 },
  { from: 'Delhi Airport', to: 'Chandigarh', price: 3200 }];


  const similarVehicles = [
  { name: 'Innova Crysta 7+1', bags: 6, seats: 7, pricePerKm: 18, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png", imageAlt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel' },
  { name: 'Kia Carens', bags: 5, seats: 6, pricePerKm: 15, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png', imageAlt: 'Kia Carens premium MPV with modern styling and comfortable interiors' },
  { name: 'Urbania', bags: 9, seats: 12, pricePerKm: 36, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png", imageAlt: 'Force Urbania luxury van for group travel with spacious seating' },
  { name: 'Brezza', bags: 4, seats: 4, pricePerKm: 12, image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png", imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design' },
  { name: 'Tempo Traveller', bags: 15, seats: 25, pricePerKm: 38, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png", imageAlt: 'Tempo Traveller 25 seater for large group travel and tours' },
  { name: 'Force Urbania', bags: 16, seats: 16, pricePerKm: 38, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png", imageAlt: 'Force Urbania 16 seater luxury van with premium features' },
  { name: 'Innova Hycross', bags: 5, seats: 6, pricePerKm: 21, image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png", imageAlt: 'Toyota Innova Hycross latest model with hybrid technology' },
  { name: 'Fortuner', bags: 5, seats: 6, pricePerKm: 35, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1eff652-1765364969211.png", imageAlt: 'Toyota Fortuner luxury SUV with premium features and comfort' },
  { name: 'Tempo Traveller', bags: 15, seats: 17, pricePerKm: 30, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png", imageAlt: 'Tempo Traveller 17 seater for group travel and tours' },
  { name: 'Maruti Ertiga', bags: 4, seats: 6, pricePerKm: 13, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png", imageAlt: 'Maruti Ertiga MPV with spacious seating capacity' },
  { name: 'Tempo Traveller', bags: 8, seats: 12, pricePerKm: 28, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png", imageAlt: 'Tempo Traveller 12 seater for medium group travel' },
  { name: 'Innova Crysta', bags: 6, seats: 6, pricePerKm: 17, image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png", imageAlt: 'Toyota Innova Crysta luxury MPV in silver color' },
  { name: 'Maruti Dzire', bags: 3, seats: 4, pricePerKm: 10, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png", imageAlt: 'White Maruti Dzire sedan car with sleek design' }];


  const specs = vehicleSpecs?.[vehicle?.name] || vehicleSpecs?.['Innova Crysta 7+1'];

  const handleBookNow = (route) => {
    navigate('/self-drive-enquiry', {
      state: {
        from: route?.from,
        to: route?.to,
        vehicle: vehicle,
        price: route?.price
      }
    });
  };

  const handleSelectCar = (selectedVehicle) => {
    navigate('/vehicle-details', {
      state: {
        vehicle: selectedVehicle
      }
    });
    window.scrollTo(0, 0);
  };

  return (
    <>
      <SEO
        title={`${vehicle?.name || 'Vehicle'} Details - Advait Tour and Travels`}
        description={`Book ${vehicle?.name || 'vehicle'} with Advait Tour and Travels. View specifications, pricing, and available routes.`}
        keywords={`${vehicle?.name}, vehicle details, cab specifications, taxi booking`}
        canonicalUrl={`${window.location?.origin}/vehicle-details`}
        ogTitle={`${vehicle?.name || 'Vehicle'} Details - Advait Tour and Travels`}
        ogDescription={`Book ${vehicle?.name || 'vehicle'} with Advait Tour and Travels. View specifications, pricing, and available routes.`}
        ogUrl={`${window.location?.origin}/vehicle-details`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Product",
          "name": vehicle?.name || 'Vehicle',
          "description": `Book ${vehicle?.name || 'vehicle'} with Advait Tour and Travels`
        }} />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-20 sm:pt-24">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12 sm:py-16 mb-8 sm:mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                {vehicle?.name || 'Vehicle Details'}
              </h1>
            </div>
          </div>

          {/* Main Content */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 max-w-7xl mx-auto">
              {/* Left Card - Vehicle Specifications */}
              <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6">
                <div className="aspect-video overflow-hidden rounded-lg mb-4 sm:mb-6">
                  <Image
                    src={vehicle?.image || 'https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png'}
                    alt={vehicle?.imageAlt || 'Vehicle image'}
                    className="w-full h-full object-cover" />

                </div>

                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                  {vehicle?.name || 'Vehicle'}
                </h2>

                <div className="space-y-3 sm:space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Seating Capacity</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.seatingCapacity}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Transmission</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.transmission}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">AC</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.ac}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Rear Ac Vents</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.rearAcVents}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Fuel Type</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.fuelType}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Luggage Carrier</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.luggageCarrier}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Sunroof</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.sunroof}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Phone Charger</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.phoneCharger}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg col-span-1 sm:col-span-2">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Music System</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.musicSystem}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Smoking Allowed</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.smokingAllowed}</span>
                    </div>
                    <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                      <span className="text-gray-600 font-medium text-sm sm:text-base">Pet Allowed</span>
                      <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.petAllowed}</span>
                    </div>
                  </div>

                  <div className="mt-4 sm:mt-6">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">Driver Details</h3>
                    <div className="space-y-2 sm:space-y-3">
                      <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                        <span className="text-gray-600 font-medium text-sm sm:text-base">Reclining Seats in Both the Front and Second Rows</span>
                        <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.recliningSeats}</span>
                      </div>
                      <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                        <span className="text-gray-600 font-medium text-sm sm:text-base">Middle Bench Seat</span>
                        <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.middleBenchSeat}</span>
                      </div>
                      <div className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                        <span className="text-gray-600 font-medium text-sm sm:text-base">Captain Seats</span>
                        <span className="text-gray-900 font-bold text-sm sm:text-base">{specs?.captainSeats}</span>
                      </div>
                      <div className="p-3 sm:p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                        <p className="text-gray-700 font-medium text-sm sm:text-base">
                          <span className="font-bold">Airport Parking Charges:</span> {specs?.airportParking}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Card - Route Pricing Table */}
              <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">Route Pricing</h2>
                
                <div className="overflow-x-auto -mx-4 sm:mx-0">
                  <div className="inline-block min-w-full align-middle">
                    <table className="min-w-full">
                      <thead>
                        <tr className="border-b-2 border-gray-200">
                          <th className="text-left py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-700 font-bold text-xs sm:text-sm lg:text-base whitespace-nowrap">From</th>
                          <th className="text-left py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-700 font-bold text-xs sm:text-sm lg:text-base whitespace-nowrap">To</th>
                          <th className="text-left py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-700 font-bold text-xs sm:text-sm lg:text-base whitespace-nowrap">One Way Price</th>
                          <th className="text-center py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-700 font-bold text-xs sm:text-sm lg:text-base whitespace-nowrap">Book</th>
                        </tr>
                      </thead>
                      <tbody>
                        {routes?.map((route, index) =>
                        <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-900 font-medium text-xs sm:text-sm lg:text-base whitespace-nowrap">{route?.from}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-900 font-medium text-xs sm:text-sm lg:text-base whitespace-nowrap">{route?.to}</td>
                            <td className="py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-gray-900 font-bold text-xs sm:text-sm lg:text-base whitespace-nowrap">
                              ₹ {route?.price} /- <span className="text-xs sm:text-sm text-gray-600 block sm:inline">(Inc. of Taxes*)</span>
                            </td>
                            <td className="py-3 sm:py-4 px-3 sm:px-4 lg:px-6 text-center">
                              <button
                              onClick={() => handleBookNow(route)}
                              className="px-3 sm:px-5 lg:px-6 py-2 sm:py-2.5 lg:py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors duration-300 text-xs sm:text-sm lg:text-base whitespace-nowrap shadow-md hover:shadow-lg">
                                BOOK NOW
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Terms & Conditions Section */}
          <div className="container mx-auto px-4 mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">Terms & Conditions</h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 max-w-7xl mx-auto">
              {similarVehicles?.map((car, index) =>
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                  <div className="aspect-video overflow-hidden">
                    <Image
                    src={car?.image}
                    alt={car?.imageAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div className="p-4 sm:p-6">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">{car?.name}</h3>
                    <div className="flex items-center justify-between mb-3 sm:mb-4">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-600 text-sm sm:text-base">Bag:</span>
                        <span className="text-gray-900 font-bold text-sm sm:text-base">{car?.bags}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-gray-600 text-sm sm:text-base">Seaters:</span>
                        <span className="text-gray-900 font-bold text-sm sm:text-base">{car?.seats}</span>
                      </div>
                    </div>
                    <p className="text-gray-700 mb-3 sm:mb-4 text-sm sm:text-base">
                      <span className="font-bold">Start at -</span> ₹{car?.pricePerKm}/- km
                    </p>
                    <button
                    onClick={() => handleSelectCar(car)}
                    className="w-full py-2 sm:py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-colors duration-300 text-sm sm:text-base">

                      SELECT CAR
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>

        {/* Contact Section with Blue Background */}
        <ContactSection />

        <Footer />
      </div>
    </>);


};

export default VehicleDetails;